import * as React from 'react';
import { inject, observer } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';
import { IUserNetwork } from '../../store/MeStore';

export type INetworks = IUserNetwork;

// Components
import Box from '../../components/Box';
import { CircularProgress } from '../../components/Progress';

import Router from './Router';

// Component
interface IProps {
    store?: IStore;
    query: { networkId: string };
}

class AppNetwork extends React.Component<IProps, {}> {

    componentWillReceiveProps(newProps: IProps) {
        const network = this.props.store!.networkStore.network;
        if (network !== null) {
            if (network.networkId !== newProps.query.networkId) {
                this.props.store!.networkStore.reset();
                this.initializeNetwork(newProps.query.networkId);
            }
        }
    }

    componentDidMount() {
        this.initializeNetwork(this.props.query.networkId);
    }

    async initializeNetwork(networkId: string) {
        localStorage.removeItem('menu_tracker');
        this.props.store!.networkStore.reset();
        // Todo: Hotfix
        try {
            await this.props.store!.networkStore.initializeNetwork(networkId, true);
            this.props.store!.meStore.updateLastNetworkId(networkId);
        } catch (err) {
            this.props.store!.networkStore.reset();
            // Todo: fix the code below
            this.props.store!.routerStore.navigate(ROUTE_PATHS.APP);
        }
    }

    handleMenuNavigate = (routeName: string) => {
        const networkId = this.props.store!.networkStore.network!.networkId;
        this.props.store!.routerStore.navigate(routeName, { networkId });
    }

    componentWillUnmount() {
        this.props.store!.networkStore.reset();
    }

    render() {
        if (this.props.store!.networkStore.network === null || this.props.store!.networkStore.person === null) {
            return (
                <Box pa={5} align="center"><CircularProgress/></Box>
            );
        }
        // const networkId = this.props.store!.networkStore.network!.networkId;
        // const role = this.props.store!.networkStore.person!.role;
        // const currentRouteName = this.props.store!.routerStore.route.name;
        return (
            <Router/>
        );
    }
}

export default inject('store')(observer(AppNetwork));


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetwork/AppNetwork.tsx